const DePrizes = () => {
  return (
    <>
      <section>
        <p>
          Bitte lesen Sie die Informationen im Abschnitt „Spielmöglichkeiten“
          auf der Website (
          <a
            href="https://de.nbafantasy.nba.com/help/rules"
            target="_blank"
            rel="noopener noreferrer"
          >
            https://de.nbafantasy.nba.com/help/rules
          </a>
          ) für alle Details zum Sammeln von Punkten.
        </p>
        <p>
          Es gibt insgesamt 30 Gewinner des Wettbewerbs, und zwar wie folgt:
        </p>
        <p>Saison lang</p>
        <p>
          Die Preise werden an die fünf (5) besten Teilnehmer mit den meisten
          Punkten auf kumulativer SaisonBasis vergeben. Um Zweifel
          auszuschließen, gibt es insgesamt fünf (5) Preise zu gewinnen, NICHT
          fünf (5) Preise für jedes Land.
        </p>
        <p>
          Pro Woche wird ein (1) Preis (insgesamt fünfundzwanzig (25)) an den
          Teilnehmer mit den meisten Punkten in einer bestimmten Woche vergeben.
          Zur Klarstellung: Es gibt insgesamt einen (1) wöchentlichen Preis zu
          gewinnen, NICHT einen (1) wöchentlichen Preis für jedes Land.
        </p>
        <p>
          {" "}
          Im Falle eines Gleichstandes zwischen den Teilnehmern für die
          Saisonpreise oder einen wöchentlichen Preis wird der Gewinner durch
          einen Tiebreaker ermittelt. Der Tiebreaker ist der Teilnehmer, der
          sich zuerst eingeloggt und sein Team erstellt hat (zum frühesten
          Datum), basierend auf den vom Sponsor gesammelten Daten.
        </p>
      </section>
      <section>
        <h3>Großer Preis – Erster (1.) Gesamtrang</h3>
        <p>
          Es wird ein (1) Hauptgewinn an den Teilnehmer mit den meisten
          gesammelten Punkten während der Dauer des Wettbewerbs vergeben
          ("Hauptgewinner").
        </p>
        <p>Der „Große Preis“ besteht aus:</p>
        <ul>
          <li>
            <p>
              Transfer vom Wohnort des Gewinners nach Paris, Frankreich.
              Entweder mit zwei (2) Economy-Class-Flugtickets für den Hin- und
              Rückflug von dem internationalen Flughafen, der dem Wohnort des
              Gewinners am nächsten ist, zu einem Flughafen in Paris,
              Frankreich. Oder mit Zugtickets für die Hin- und Rückfahrt von dem
              Bahnhof, der dem Wohnort des Gewinners am nächsten ist, nach
              Paris, Frankreich (wie vom Sponsor nach eigenem Ermessen
              festgelegt und mitgeteilt).
            </p>
            <ul>
              <li>
                <p>
                  Die Auswahl der Sitzplätze liegt im alleinigen Ermessen des
                  Veranstalters.
                </p>
              </li>
              <li>
                <p>
                  Die genaue Beförderungsart, die Daten und Zeiten werden vom
                  Sponsor nach eigenem Ermessen festgelegt.
                </p>
              </li>
            </ul>
          </li>
          <li>
            <p>
              Ein (1) Hotelzimmer für zwei (2) Personen in Paris für insgesamt
              drei (3) Nächte in einem 3- bis 4-Sterne-Hotel.
            </p>
            <ul>
              <li>
                <p>
                  Hotels, Zimmer und Daten werden vom Sponsor nach eigenem
                  Ermessen ausgewählt.{" "}
                </p>
              </li>
            </ul>
          </li>
          <li>
            <p>
              Zwei (2) Eintrittskarten für ein (1) NBA Paris Game während der
              NBA-Saison 2027/28 (das „Spiel“)
            </p>
            <ul>
              <li>
                <p>
                  Der genaue Spieltermin liegt im alleinigen Ermessen des
                  Sponsors.
                </p>
              </li>
            </ul>
          </li>
          <li>
            <p>
              Eine Trophäe für den ersten Platz, die persönlich oder per Kurier
              an die Adresse des Gewinners geliefert wird, was im alleinigen
              Ermessen des Sponsors liegt.
            </p>
          </li>
        </ul>
        <p>Der ungefähre Gesamtwert des Hauptpreises beträgt 2.500,00 €.</p>
        <p>
          Der Gewinner kann einen (1) Freund bzw. eine Freundin oder ein
          Familienmitglied bestimmen, um mit ihm oder ihr daran teilzunehmen
          (der „Gast“).
        </p>
        <p>
          Personen, die in einer früheren Saison den Hauptpreis gewonnen haben,
          sind nicht berechtigt, den Hauptpreis zu erhalten. In einem solchen
          Fall wird der Hauptpreis an den nächstberechtigten Teilnehmer
          vergeben. Der ursprünglich berechtigte Gewinner des Hauptpreises
          erhält stattdessen den Preis für den zweiten (2.) Platz.
        </p>
      </section>
      <section>
        <p>
          Vier (4) zusätzliche sekundäre Preise für die gesamte Saison – Zweiter
          (2.) bis fünfter (5.) Gesamtrang Diese vier (4) zusätzlichen
          Sekundärpreise werden an die Teilnehmer mit den zweit- (2.), dritt-
          (3.), viert- (4.) und fünft- (5.) meisten kumulierten Punkten während
          der Dauer des Wettbewerbs (jeweils ein „Sekundärpreisgewinner“)
          vergeben.
        </p>
        <ul>
          <li>
            <p>
              Preis für den zweiten (2.) Platz: NBA-Store-Geschenkkarte x 200,00
              € auf{" "}
              <a
                href="https://nbastore.eu/"
                target="_blank"
                rel="noopener noreferrer"
              >
                nbastore.eu
              </a>{" "}
            </p>
          </li>
          <li>
            <p>
              Preis für den dritten (3.) Platz: NBA-Store-Geschenkkarte x 200,00
              € auf{" "}
              <a
                href="https://nbastore.eu/"
                target="_blank"
                rel="noopener noreferrer"
              >
                nbastore.eu
              </a>
            </p>
          </li>
          <li>
            <p>
              Preis für den vierten (4.) Platz: NBA-Store-Geschenkkarte x 200,00
              € auf{" "}
              <a
                href="https://nbastore.eu/"
                target="_blank"
                rel="noopener noreferrer"
              >
                nbastore.eu
              </a>
            </p>
          </li>
          <li>
            <p>
              Preis für den fünften (5.) Platz: NBA-Store-Geschenkkarte x 200,00
              € auf{" "}
              <a
                href="https://nbastore.eu/"
                target="_blank"
                rel="noopener noreferrer"
              >
                nbastore.eu
              </a>
            </p>
          </li>
        </ul>
      </section>
      <section>
        <h3>Wöchentlich:</h3>
        <p>
          Fünfundzwanzig (25) zusätzliche Preise werden an den Teilnehmer mit
          den meisten Punkten in einer bestimmten Woche vergeben (jeweils ein
          „Wochenpreisgewinner“). Ein (1) wöchentlicher Preis wird pro Woche
          vergeben x 25 Wochen Wettbewerbsdauer insgesamt. Der wöchentliche
          Preis besteht aus einer digitalen Kopie von „NBA 2K27“ und einer
          NBA-Store-Geschenkkarte im Wert von 100,00 € unter{" "}
          <a
            href="https://nbastore.eu/"
            target="_blank"
            rel="noopener noreferrer"
          >
            nbastore.eu
          </a>{" "}
          (wird vom Sponsor nach eigenem Ermessen festgelegt). Der ungefähre
          Gesamtwert eines wöchentlichen Preises beträgt 150,00 €.
        </p>
        <p>
          Um an den wöchentlichen Preisen teilnehmen zu können, müssen die
          Benutzer entweder vor Beginn der Saison oder mindestens 14 Tage vor
          Beginn der jeweiligen Spielwoche in das Spiel eingestiegen sein.
        </p>
        <p>
          Eine vollständige Liste der Spielwochen finden Sie im Abschnitt{" "}
          <a
            href="https://de.nbafantasy.nba.com/help/rules"
            target="_blank"
            rel="noopener noreferrer"
          >
            „Spielmöglichkeiten“
          </a>
          . Die Spielwochen können nach eigenem Ermessen des Sponsors geändert
          werden.
        </p>
      </section>
      <section>
        <h3>Teilnahmeberechtigung:</h3>
        <p>
          Die Werbeaktion ist beschränkt auf Einwohner von Belgien, Dänemark,
          Deutschland, Finnland, Frankreich, Griechenland, Irland, den
          Niederlanden, Norwegen, Österreich, Portugal, der Schweiz, Serbien,
          Spanien, der Tschechischen Republik, Ungarn und dem Vereinigten
          Königreich (zusammen das „Gebiet“), die zum Zeitpunkt der Einreichung
          des Wettbewerbsbeitrags achtzehn (18) Jahre oder älter sind (jeweils
          ein „Teilnehmer“). Um Zweifel auszuschließen, sind Personen mit
          Wohnsitz außerhalb der oben genannten Gerichtsbarkeiten und/oder
          Teilnehmer, die zum Zeitpunkt der Einreichung des Wettbewerbsbeitrags
          das achtzehnte (18.) Lebensjahr noch nicht vollendet haben, nicht zur
          Teilnahme an dieser Werbeaktion berechtigt. Der Sponsor, wie unten
          definiert, behält sich das Recht vor, die Teilnahmeberechtigung jedes
          Teilnehmers zu bestätigen, einschließlich der Überprüfung seines
          Alters.
        </p>
      </section>
    </>
  );
};

export { DePrizes };
